import EchoCard from '@/components/EchoCard'
import chartBg from '@/assets/chart_bg.png'
import listBg from '@/assets/list_bg.png'
import basicBg from '@/assets/basic_bg.png'
import Image from 'next/image'
import influencerBg from '@/assets/influencer_bg.png'

const NotLoginChartCard = () => {
  return (
    <EchoCard>
      <Image src={chartBg.src} width={1400} height={400} />
    </EchoCard>
  )
}

export const NotLoginListCard = () => {
  return (
    <EchoCard>
      <Image src={listBg.src} width={1400} height={300} />
    </EchoCard>
  )
}

export const NotLoginBasicCard = () => {
  return (
    <EchoCard>
      <Image src={basicBg.src} width={1400} height={270} />
    </EchoCard>
  )
}

export const NotLoginInfluencerCard = () => {
  return (
    <EchoCard>
      <Image src={influencerBg.src} width={1400} height={650} />
    </EchoCard>
  )
}

export default NotLoginChartCard
